import React, { useState } from 'react';
import { ActionMenu, Button, Icon } from '@paypalcorp/pp-react';
import templateData from '../utility/getTemplateData';
import { showSpinnerOverlay } from '../utility/helper';
import {
  getCurrentLangName,
  updatePageLanguageByLocale,
  getLanguageOptions,
} from '../utility/languageSelector';

const languagesList = templateData.languagesList;

export default function LanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const currentLanguage = getCurrentLangName();
  const options = getLanguageOptions();

  if (!options) return null;

  const openMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const getLocale = (index) => {
    const lang = languagesList[index];
    const locale = `${lang.split('-')[1].split('_')[0]}_${
      templateData.country
    }`;
    return locale;
  };

  const selectMenuItem = (index) => {
    showSpinnerOverlay();
    const locale = getLocale(index);
    updatePageLanguageByLocale(locale);
  };

  return (
    <div className="lang_selector">
      <Button size="sm" icon onClick={openMenu}>
        {currentLanguage}
        <Icon name="chevron-up" size="xs" />
      </Button>
      <ActionMenu
        isOpen={isOpen}
        options={options}
        onSelection={selectMenuItem}
        onClose={closeMenu}
      />
    </div>
  );
}
